var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8H2.75M9.75 8H10.975C11.1142 8 11.2478 8.05531 11.3462 8.15377C11.4447 8.25223 11.5 8.38576 11.5 8.525V14.475C11.5 14.6142 11.4447 14.7478 11.3462 14.8462C11.2478 14.9447 11.1142 15 10.975 15H1.525C1.38576 15 1.25223 14.9447 1.15377 14.8462C1.05531 14.7478 1 14.6142 1 14.475V8.525C1 8.38576 1.05531 8.25223 1.15377 8.15377C1.25223 8.05531 1.38576 8 1.525 8H2.75H9.75ZM9.75 8V4.5C9.75 3.33363 9.05 1 6.25 1C3.45 1 2.75 3.33363 2.75 4.5V8H9.75Z",
    stroke: "#272B3E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.47ca7b669ef64364319510a4315a2116.svg";
export { ForwardRef as ReactComponent };